import { get } from 'lodash';

/**
 * @param Array array such as [{ id, checkboxes: [{ id, ... }]}]
 * @param String key
 * @returns Array [id, id, ...]
 */
export const CHECKBOXES_TREE_REDUCER = (array, key = 'checkboxes') => {
  if (!array.length) return [];
  return array.reduce((acc, el) => [...acc, el.id, ...CHECKBOXES_TREE_REDUCER(get(el, [key], []))], []);
};
export const AUTOCOMPLETE_URL = '/api/frontend/hotels/autocomplete';
export const DOWNLOAD_URL_AMCHART = '/home/chart/download_file';
